import React, { useEffect, useRef, useState } from 'react'
import { CSVLink } from 'react-csv';
import { useSelector } from 'react-redux';
import { useDispatch } from 'react-redux';
import { Link } from 'react-router-dom';
import { LoaderTwo } from '../../../../components/loader/LoaderTwo';
import PageTitle from '../../../../components/partials/PageTitle'
import pdf from "../../../../assets/images/img-icons/pdf.png";
import excel from "../../../../assets/images/img-icons/excel.png";
import PaginationLinks from '../../../../components/pagination/PaginationLinks';
import { MdRemoveRedEye } from 'react-icons/md';
import { getAllLifeCover, resetLifeCoverStatus } from '../../../../redux/slice/lifecover/lifecoverSlice';

const Charges = () => {
    const CCPdfRef = useRef();
  const [filterBy, setFilterBy] = useState('');

    const dispatch = useDispatch()

    const {isSuccess, isLoading, all_life_cover} = useSelector((state) => state.lifecover)

    const handleSearch = (e) => {
      e.preventDefault();
      if (filterBy?.length) {
        const payload = {
          search: filterBy,
          pageNum: 1
        };
        dispatch(getAllLifeCover(payload));
      }
    };
    

    const breadcrumb = {
        from: {
          title: "Life Cover",
          link: "/admin/settings/life-cover",
        },
        current: {
          title: "Life Cover Table",
          link: null,
        },
    };


    const fetchChargesHandler = async (pageNum) => {
        // setPageNumber(pageNum);
        dispatch(getAllLifeCover({pageNum, search: filterBy}));
    };

    useEffect(() => {
      if (!filterBy) {
        dispatch(getAllLifeCover({pageNum:1, search: ''}));
      }
      }, [dispatch, filterBy]);
    
      useEffect(() => {
        if (isSuccess) {
          dispatch(resetLifeCoverStatus());
        }
      }, [dispatch, isSuccess]);

    if (all_life_cover?.length === 0 && isLoading) {
    return (
        <div className='mt-2'>
        <LoaderTwo />
        </div>
    );
    }
  return (
    <>
        {/* page title */}
        <PageTitle title='Life Cover' breadcrumb={breadcrumb} />
        {/* end page title */}
        <div className='row card p-1' style={{ margin: "auto 1px" }}>
            <div className='mb-1 pb-1 border border-bottom-1 border-start-0 border-end-0 border-top-0'>
                <div className={`d-flex justify-content-between align-items-center`}>
                    <div>
                        <Link
                            className='d-flex gap-2 justify-content-center align-items-center rounded-1 btn-primary cursor-p px-3'
                            style={{ height: "30px", padding: "10px 10px" }}
                            to='/admin/settings/life-cover/add-life-cover'
                        >
                            <span>
                                <i className='mdi mdi-plus fs-4'></i>
                            </span>
                            <span  
                                className='text-dark pe-2 text-white'
                            >
                                Create Life Cover
                            </span>
                        </Link>
                    </div>
                    <div className='d-flex justify-content-between align-items-center gap-3'>
                        <form
                              onSubmit={handleSearch}
                            className='d-flex bg-primary-1 align-items-center '
                            style={{ height: "30px", width: "217px" }}
                        >
                            <input
                            type='search'
                            value={filterBy}
                            className='border-0'
                            placeholder='Search...'
                            onChange={(e) => setFilterBy(e.target.value)}
                            style={{ height: "28px", marginLeft: "1px", outline: "none" }}
                            />
                            <button
                            type='submit'
                            className='btn btn-primary btn-sm d-flex align-items-center gap-1'
                            style={{ height: "28px" }}
                            >
                            <i className='uil uil-search text-white fs-4'></i>
                            </button>
                        </form>
                        <div className=' d-flex align-items-center border '>
                            <span
                            className='bg-info me-2 text-white'
                            style={{ padding: "3px" }}
                            >
                            Export to
                            </span>
                            <span
                            href='#'
                            id='btnExport'
                            className='me-1'
                            title='Export to Pdf'
                            // onClick={generatePDF}
                            >
                            <img src={pdf} alt='export-pdf' style={{ height: "20px" }} />
                            </span>
                            <CSVLink
                            data={[]}
                            style={{ fontWeight: "bolder" }}
                            filename='Available Users'
                            >
                                <span
                                    href='#'
                                    id='btnExport'
                                    className='mr-1'
                                    title='Export to Excel'
                                >
                                    <img
                                    src={excel}
                                    alt='export-excel'
                                    style={{ height: "20px", marginRight: "5px" }}
                                    />
                                </span>
                            </CSVLink>
                        </div>
                    </div>
                </div>
            </div>
            <div className='col-12'>
          <div className='position-relative'>
            <div className='row'>
              <div className='col-sm-12'>
                <div className='table-responsive'>
                  <table
                    className='table table-centered table-striped nowrap w-100 no-footer'
                    ref={CCPdfRef}
                  >
                    <thead>
                      <tr>
                        <th
                          className='sorting'
                          tabIndex='0'
                          rowSpan='1'
                          colSpan='1'
                          style={{ width: "225.8px" }}
                          aria-label='Customer: activate to sort column ascending'
                        >
                          Name
                        </th>
                        <th
                          className='sorting'
                          tabIndex='0'
                          rowSpan='1'
                          colSpan='1'
                          style={{ width: "167.8px" }}
                        >
                          Policy Category
                        </th>
                        <th
                          className='sorting'
                          tabIndex='0'
                          rowSpan='1'
                          colSpan='1'
                          style={{ width: "167.8px" }}
                          aria-label='Email: activate to sort column ascending'
                        >
                          Description
                        </th>
                          <th
                            className='sorting text-center'
                            tabIndex='0'
                            rowSpan='1'
                            colSpan='1'
                            style={{ width: "95.8px" }}
                            aria-label='Status: activate to sort column ascending'
                          >
                            Action
                          </th>
                      </tr>
                    </thead>
                    {all_life_cover?.life_cover_data?.data?.length ? (
                      <tbody>
                        {all_life_cover?.life_cover_data?.data?.map((item, i) => {
                          return (
                            <tr key={i}>
                              <td>
                                <span>{item.life_cover_name}</span>
                              </td>
                              <td>
                                {item?.policy_category === "1" &&
                                  "General Policy"}
                                {item?.policy_category === "2" &&
                                  "Savings Policy"}
                                {item?.policy_category === "3" && "Credit Life"}
                              </td>
                              <td className=''>
                                {item?.description}
                              </td>
                                <td className='text-center'>
                                  <Link
                                    to={`/admin/settings/life-cover/${item?.id}`}
                                    className='text-left'
                                  >
                                    <MdRemoveRedEye
                                      className='text-primary'
                                      style={{
                                        fontSize: "20px",
                                        textAlign: "start",
                                      }}
                                    />
                                  </Link>
                                </td>
                            </tr>
                          );
                        })}
                      </tbody>
                    ) : null}
                  </table>
                </div>
                {all_life_cover?.life_cover_data?.data?.length < 1 ? (
                  <h5 className='alert alert-info'>No result found!</h5>
                ) : null}
                <div className='row mt-2'>
                  <div className='col-sm-12 col-md-6'>
                    <div
                      className='dataTables_info table-pages'
                      id='products-datatable_info'
                      role='status'
                      aria-live='polite'
                    >
                      Showing all charges {all_life_cover?.life_cover_data?.from} to{" "}
                      {all_life_cover?.life_cover_data?.to} of{" "}
                      {all_life_cover?.life_cover_data?.total}
                    </div>
                  </div>
                  <div className='col-sm-12 col-md-6'>
                    <PaginationLinks
                      paginationData={all_life_cover?.life_cover_data}
                      getNextPage={fetchChargesHandler}
                    />
                  </div>
                </div>
              </div>
            </div>
            {/* {(isFiltering || isSearching) && (
                  <div
                    className='position-absolute top-0 start-0 end-0 bottom d-flex justify-content-center align-items-center transparent-primary z-1000 '
                    style={{ height: "100%" }}
                  >
                    <div className='mx-auto'>
                      <BounceLoader
                        color='#090b8f'
                        loading={true}
                        // cssOverride={override}
                        size={50}
                        aria-label='Loading Spinner'
                        data-testid='loader'
                        className='ms-3'
                      />
                      <span className='fw-bolder text-primary-1 ms-2'>
                        Please wait...
                      </span>
                    </div>
                  </div>
                )} */}
          </div>
        </div>
        </div>
    </>
  )
}

export default Charges